import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { grid } from '@finect/tabular-utils/grid';

export const ArticleSide = styled.div`
  float: ${({ position }) => position};
  width: ${({ full }) => (full ? '100%' : 'auto')};
  max-width: ${grid(4)}px;
  padding-left: ${({ position }) => (position === 'right' ? '48px' : 0)};
  padding-right: ${({ position }) => (position === 'right' ? 0 : '48px')};
  margin: ${({ position }) => (position === 'right' ? '0 auto 30px 0' : '0 0 30px auto')};

  ${maxMediaQueries.tablet`
    max-width: ${grid(3)}px;
  `};

  ${maxMediaQueries.phablet`
    float: none;
    max-width: ${grid(4)}px;
    padding-left: 0;
    padding-right: 0;
    margin: 0 auto 30px;
  `};
`;
